var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.form.labels.length
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      return _vm.$refs.time.open()
    }
    _vm.e1 = function ($event) {
      return _vm.$refs.labels.open()
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }